/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferTagsOut
 */
export interface OfferTagsOut {
    /**
     * 
     * @type {number}
     * @memberof OfferTagsOut
     */
    tagId: number;
    /**
     * 
     * @type {string}
     * @memberof OfferTagsOut
     */
    offerTag: string;
    /**
     * 
     * @type {Date}
     * @memberof OfferTagsOut
     */
    modificationDate: Date;
}

export function OfferTagsOutFromJSON(json: any): OfferTagsOut {
    return OfferTagsOutFromJSONTyped(json, false);
}

export function OfferTagsOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferTagsOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tagId': json['tagId'],
        'offerTag': json['offerTag'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function OfferTagsOutToJSON(value?: OfferTagsOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tagId': value.tagId,
        'offerTag': value.offerTag,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


